import React, { useState } from 'react'
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
} from '@material-ui/core'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import Dialog from 'components/dialog'
import { useStyles } from './styles'
import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { RevokeCoachEndorsement } from './queries'

const reasonsForRemoval = [
  'No longer works at my facility',
  'Lack of engagement',
  'Other',
]

const RemoveSponsorshipModal = ({ endorsementId, open, onClose, refetch }) => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const [reason, setReason] = useState('')
  const [showError, setShowError] = useState(false)

  const [RemoveSponsorship, { loading }] = useMutation(RevokeCoachEndorsement)

  const removeSponsorship = async () => {
    try {
      if (!reason) {
        setShowError(true)
        return
      }
      const response = await RemoveSponsorship({
        variables: {
          coachEndorsementId: endorsementId,
          reason: reason,
        },
      })
      if (response?.data?.revokeCoachEndorsement) {
        enqueueSnackbar('PGA Coach access successfully removed', {
          variant: 'success',
        })
        refetch()
        onClose()
      }
    } catch (e) {
      enqueueSnackbar('Sorry, an error occurred', {
        variant: 'error',
      })
    }
  }

  return (
    <Dialog maxWidth="xs" fullWidth isOpen={open} onClose={onClose}>
      {({ closeDialog }) => (
        <>
          <DialogTitle>Remove Sponsorship</DialogTitle>
          <DialogContent style={{ overflowY: 'initial' }}>
            <Typography
              variant="body1"
              color="textSecondary"
              style={{ marginBottom: '16px' }}
            >
              Removing your PGA Coach sponsorship is an action that cannot be
              undone. Please provide a reason for removing platform access.
            </Typography>
            <FormControl variant="outlined">
              <InputLabel id="remove-select">Select a Reasoning *</InputLabel>
              <Select
                labelId="remove-select"
                id="simple-select-outlined"
                value={reason}
                onChange={e => setReason(e.target.value)}
                label="Select a Reasoning *"
              >
                {reasonsForRemoval.map(reason => (
                  <MenuItem key={reason} value={reason}>
                    {reason}
                  </MenuItem>
                ))}
              </Select>
              {showError && !reason && (
                <FormHelperText error={true}>
                  Please, select a reasoning
                </FormHelperText>
              )}
            </FormControl>
          </DialogContent>

          <DialogActions>
            <Button color="primary" onClick={closeDialog}>
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={<CancelOutlinedIcon />}
              className={classes.removeButton}
              size="large"
              onClick={removeSponsorship}
              disabled={loading}
            >
              Remove
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default RemoveSponsorshipModal
